import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
import AOS from 'aos'
import throttle from 'lodash/throttle';
import '../../node_modules/jquery-parallax.js/parallax.min.js'
import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyInterchange, } from './_lazy-load'
import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad';
import './_skip-link-focus-fix'
import './_acf-map'
import './_fixed-header'
import './_header-height'
import './_hero-slider'
import './_notification'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
import './_ie'
// import './_faqs_accordion'
// import './_fragmentURLs'
/* Additional Scripts */
// import { randomString } from './_random-string'

// Foundation
$(document).foundation();

// Inline SVG
inlineSVG();

// Smooth Scroll on page load
smoothScrollOnPageLoad();

// Lazy-load on DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {
    
    lazyImages();
    lazyInterchange();
    // lazyBackgrounds();
    // lazyVideos();
    // lazyOembeds();

}, false);

// Lazy-load on scroll event
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );
// window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
// window.addEventListener( 'scroll', throttle( lazyOembeds, 75 ), { passive: true } );

// AOS
AOS.init();

// ** Homepage Sign-up Form
// 1. Prevent the form from submitting
// 2. Add text field value to cookie or localStorage

const $homepage_signup_form = $( '#homepage-signup-form' );

$homepage_signup_form.submit( function( event ) {
    event.preventDefault();

    let field_value = document.getElementById('homepage-signup-field').value;
    sessionStorage.setItem( "homepage_signup_email", field_value);

    window.location.assign('/contact/sales-contact/'); 
});


jQuery( function($) {

    // ** Detect iOS
    
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if ( iOS ) {
        $('body').addClass('is-ios');
    }

    // ** Homepage CTA

    var $cta_slide_text = $('strong', '#homepage-bottom-cta');
    var textIndex = -1;
    $cta_slide_text.wrapAll( "<div class='js-cta-slider-text display-inline-block'></div>" );

    function fadeText() {
        ++textIndex;

        $cta_slide_text.eq( textIndex % $cta_slide_text.length ).parent().animate({
            width: $cta_slide_text.eq( textIndex % $cta_slide_text.length ).width()
        }, 500);

        $cta_slide_text
            .eq( textIndex % $cta_slide_text.length )
            .delay(250)
            .fadeIn(2000)
            .delay(2000)
            .fadeOut(2000, fadeText);
    }
    
    fadeText.call();

    // ** AJAX Load More
    
    $.fn.almComplete = function(alm) {
        console.log('Posts have been loaded');
    };

    $.fn.almDone = function(alm) {
        $('button.alm-load-more-btn.more.done').parent().fadeOut(150, function() {
            $(this).hide();
            console.log('All posts have been loaded');
        });
    };


    // ** Back Button for Contact Subpages
    
    const $back_button = $( '.back-to-contact-page' );

    if ( $back_button.length ) {
        $('.js-append-back-button .grid-x, .pardot-form > .editor-component .grid-x').prepend( $back_button );
        
        setTimeout( function() {
            $back_button.get(0).classList.add('is-visible');
        }, 250 );
    }


    // ** Pardot Forms

    // label
    const $pd_label = $( '.field-label', '.pardot-form' ),
          pd_label_count = $pd_label.length;

    function populateEmailField ( 
        url = '/contact/sales-contact/', 
        storageItem = 'homepage_signup_email', 
        target = '.pardot-form input[placeholder="Email"]' 
    ) {
        if ( $('.pardot-form').length ) {
            if ( sessionStorage.getItem(storageItem) != '' ) {
                let signup_email = sessionStorage.getItem(storageItem);
                document.querySelector(target).value = signup_email;
            }
        }
    }
    
    // Create placeholder attributes from the field label
    $pd_label.each( function(i) {
        var $text = $(this).text().replace( ':', '' );
        $(this).siblings( 'input, textarea' ).attr( 'placeholder', $text );

        if ( ( pd_label_count - 1 ) == i ) {
            setTimeout(
                function() {
                    $( '.pardot-form' ).addClass( 'js-load-placehdolders' );
                    populateEmailField();
                },
                250
            );
        }
    } );

} );










